import React from 'react'
import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'

export default function Menu({display,setMenu}) {

     
 
    function closeMenu() {
        setTimeout(() => {
            setMenu(false)
        }, 500);
    }

  return (
    <div className='menu' style={{top : display ?  '10vh' : '-120vh'}}>
        <div className="pages">
            <div className="text one">
                <Link to='/' onClick={closeMenu} >
                    <h1 className={useLocation().pathname == '/' ? 'active' : ''} >Home</h1>
                </Link>
                <Link to='/work' onClick={closeMenu}>
                    <h1 className={useLocation().pathname == '/work' ? 'active' : ''} >Work</h1>
                </Link>
            </div>
            <div className="text two">
                <Link to='/skills' onClick={closeMenu}>
                    <h1 className={useLocation().pathname == '/skills' ? 'active' : ''}>Skills</h1>
                </Link>
                <a href="mailto: badreddineibril@gmail.com" onClick={closeMenu}>
                    <h1 className={useLocation().pathname == '/contact' ? 'active' : ''}>Contact</h1>
                </a>
            </div>
        </div>
        <div className="socio">
            <a href="https://github.com/BadreddineIbril" target='_blank'>
                <img src="https://cdn-icons-png.flaticon.com/128/2111/2111432.png" alt="" />
            </a>
            <a href="https://www.linkedin.com/in/badreddine-ibril-6554b9236/" target='_blank'>
                <img src="https://cdn-icons-png.flaticon.com/128/1384/1384014.png" alt="" />
            </a>
            <a href="https://www.instagram.com/badr_ibril/" target='_blank'>
                <img src="https://cdn-icons-png.flaticon.com/128/1384/1384015.png" alt="" />
            </a>
            <a href="https://twitter.com/Badrib2003" target='_blank'> 
                <img src="https://cdn-icons-png.flaticon.com/128/2168/2168336.png" alt="" />
            </a>
        </div>
    </div>
  )
}
